<template>
  <layout-basic>


    <h3 class="title is-4">Edit test type</h3>

    <form action="">

      <section>
        <b-steps>

          <b-step-item step="1" label="General" :clickable="isStepsClickable">
            <test-type-general/>
          </b-step-item>

          <b-step-item step="2" label="Test method" :clickable="isStepsClickable">
            <test-type-method/>
          </b-step-item>


          <b-step-item step="3" label="Validator" :clickable="isStepsClickable">
            <test-type-validator/>
          </b-step-item>


          <b-step-item step="4" label="Alert" :clickable="isStepsClickable" disabled>
            <test-type-alert/>
          </b-step-item>
          <br>
          <br>
          <template
            slot="navigation"
            slot-scope="{previous, next}">
            <b-button
              outlined
              :disabled="previous.disabled"
              class="is-pulled-left"
              @click.prevent="previous.action">
              Previous

            </b-button>

            <b-button
              v-if="!next.disabled"
              outlined
              :disabled="next.disabled"
              class="is-pulled-right"
              @click.prevent="next.action">
              Next
            </b-button>

            <button v-if="next.disabled" class="button is-primary is-pulled-right" @click="formSubmit">Save</button>
          </template>
        </b-steps>
      </section>
      <br>
      <br>
      <br>
      <br>
    </form>
  </layout-basic>
</template>

<script>

import TestTypeGeneral from '@/components/TestType/Form/General'
import TestTypeMethod from '@/components/TestType/Form/TestMethod'
import TestTypeAlert from '@/components/TestType/Form/Alert'
import TestTypeValidator from '@/components/TestType/Form/Validator'
import TestTypeService from '@/services/TestTypeService'
import LayoutBasic from '@/layouts/LayoutBasic'


export default {
  name: 'TestTypeEdit',

  components: {
    LayoutBasic,
    TestTypeGeneral,
    TestTypeMethod,
    TestTypeAlert,
    TestTypeValidator
  },

  data() {
    return {
      isStepsClickable:true,
      formData: {
        name: '',
        testMethod: {testConfig: {}},
        testMethodConfig: {},
        notificationService: {
          error: {notificationConfig: {}},
          warning: {notificationConfig: {}},
        },
        notificationServiceConfig: {
          error: {},
          warning: {}
        },
      },
    }
  },

  created() {
    this.getTestType()
  },

  methods: {
    formSubmit(e) {
      e.preventDefault()
      const testTypeId = this.$route.params.testTypeId;
      const requestData = this.$store.getters['testType/testTypeRequestData'];
      TestTypeService.update(testTypeId, requestData)
        .then(response => {
          this.$router.push({path: '/test-types'})
        })
    },

    getTestType() {
      const testTypeId = this.$route.params.testTypeId;

      TestTypeService.get(testTypeId)
        .then(response => {
          this.$store.dispatch('testType/setForUpdate', response.data)
        })
    }
  }
}
</script>
